export default __webpack_public_path__ + "static/media/dsv-ups.b20ab162.svg";